// A sign-in record's id in the address, `me/activity/<seq>` (01-the-console.md
// § the address): the AUDIT stream sequence of the message the record was
// read from, which the signins verb answers as `seq` — unique in the
// install, stable for the record's life (02-the-auth-service.md § the audit
// records; hq decision 0072). A record without one, from an older service,
// has no page.

import type { SignInRecord } from "../../wire/auth.ts";

/** recordId is a record's id in the address, or undefined where it carries no sequence. */
export function recordId(x: Pick<SignInRecord, "seq">): string | undefined {
  const n = x.seq;
  return n !== undefined && Number.isSafeInteger(n) && n > 0 ? String(n) : undefined;
}
